<div class="con-status__container">
  <span class="con-status__status-icon" [ngClass]="getStatus()"></span>
  <span class="con-status__status-text">{{ isConnected ? "Online" : "Offline" }}</span>
</div>
